function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var AdminServerConnection = /*#__PURE__*/function () {
  function AdminServerConnection(mod) {
    _classCallCheck(this, AdminServerConnection);
    this.mod = mod;
    this.state = 'idle';
    this.timer = null;
    this.tried_fallback = false;
  }
  return _createClass(AdminServerConnection, [{
    key: "start",
    value: function () {
      var _start = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this$mod$app;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if ((_this$mod$app = this.mod.app) !== null && _this$mod$app !== void 0 && _this$mod$app.BROWSER) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              if (!(this.state === 'connected')) {
                _context.n = 2;
                break;
              }
              return _context.a(2);
            case 2:
              _context.n = 3;
              return this.acceptExistingServer();
            case 3:
              if (!_context.v) {
                _context.n = 4;
                break;
              }
              return _context.a(2);
            case 4:
              if (!(this.state === 'connected')) {
                _context.n = 5;
                break;
              }
              return _context.a(2);
            case 5:
              this.setState(this.configuredPeer() ? 'configured' : 'fallback');
              if (this.state === 'fallback') {
                this.connectFallback();
              }
              this.armTimeout();
            case 6:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function start() {
        return _start.apply(this, arguments);
      }
      return start;
    }()
  }, {
    key: "acceptExistingServer",
    value: function () {
      var _acceptExistingServer = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this$mod$app2;
        var expected, network, peer;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              expected = this.mod.server_publickey;
              network = (_this$mod$app2 = this.mod.app) === null || _this$mod$app2 === void 0 ? void 0 : _this$mod$app2.network;
              if (!(!expected || !network)) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2, false);
            case 1:
              _context2.n = 2;
              return this.existingPeer(network, expected);
            case 2:
              peer = _context2.v;
              if (peer) {
                _context2.n = 3;
                break;
              }
              return _context2.a(2, false);
            case 3:
              return _context2.a(2, this.onHandshake(peer));
          }
        }, _callee2, this);
      }));
      function acceptExistingServer() {
        return _acceptExistingServer.apply(this, arguments);
      }
      return acceptExistingServer;
    }()
  }, {
    key: "existingPeer",
    value: function () {
      var _existingPeer = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(network, expected) {
        var peer, peers, list, _t, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              if (!(typeof network.getPeer === 'function')) {
                _context3.n = 5;
                break;
              }
              _context3.p = 1;
              _context3.n = 2;
              return network.getPeer(expected);
            case 2:
              peer = _context3.v;
              if (!((peer === null || peer === void 0 ? void 0 : peer.publicKey) === expected)) {
                _context3.n = 3;
                break;
              }
              return _context3.a(2, peer);
            case 3:
              _context3.n = 5;
              break;
            case 4:
              _context3.p = 4;
              _t = _context3.v;
            case 5:
              if (!(typeof network.getPeers !== 'function')) {
                _context3.n = 6;
                break;
              }
              return _context3.a(2, null);
            case 6:
              _context3.p = 6;
              _context3.n = 7;
              return network.getPeers();
            case 7:
              peers = _context3.v;
              list = Array.isArray(peers) ? peers : [];
              return _context3.a(2, list.find(function (peer) {
                return (peer === null || peer === void 0 ? void 0 : peer.publicKey) === expected;
              }) || null);
            case 8:
              _context3.p = 8;
              _t2 = _context3.v;
              return _context3.a(2, null);
          }
        }, _callee3, null, [[6, 8], [1, 4]]);
      }));
      function existingPeer(_x, _x2) {
        return _existingPeer.apply(this, arguments);
      }
      return existingPeer;
    }()
  }, {
    key: "configuredPeer",
    value: function configuredPeer() {
      var _this$mod$app3;
      var peers = (_this$mod$app3 = this.mod.app) === null || _this$mod$app3 === void 0 || (_this$mod$app3 = _this$mod$app3.options) === null || _this$mod$app3 === void 0 ? void 0 : _this$mod$app3.peers;
      if (!Array.isArray(peers)) {
        return null;
      }
      return peers.find(function (peer) {
        var protocol = String((peer === null || peer === void 0 ? void 0 : peer.protocol) || '');
        return (peer === null || peer === void 0 ? void 0 : peer.host) && (peer === null || peer === void 0 ? void 0 : peer.port) && (protocol === 'http' || protocol === 'https');
      }) || null;
    }
  }, {
    key: "pagePeer",
    value: function pagePeer() {
      var page = window.location;
      var protocol = page.protocol === 'https:' ? 'https' : 'http';
      return {
        host: page.hostname,
        port: Number(page.port || (protocol === 'https' ? 443 : 80)),
        protocol: protocol,
        synctype: 'lite'
      };
    }
  }, {
    key: "samePeer",
    value: function samePeer(left, right) {
      if (!left || !right) {
        return false;
      }
      return String(left.host).toLowerCase() === String(right.host).toLowerCase() && String(left.port) === String(right.port) && left.protocol === right.protocol;
    }
  }, {
    key: "connectFallback",
    value: function connectFallback() {
      this.tried_fallback = true;
      var page = this.pagePeer();
      if (this.samePeer(this.configuredPeer(), page)) {
        return;
      }
      this.setState('fallback');
      if (typeof this.mod.connectPeer === 'function') {
        this.mod.connectPeer(page);
      }
    }
  }, {
    key: "armTimeout",
    value: function armTimeout() {
      var _this = this;
      this.clearTimer();
      this.timer = setTimeout(function () {
        _this.timer = null;
        if (_this.state === 'connected' || _this.state === 'failed') {
          return;
        }
        if (!_this.tried_fallback) {
          _this.connectFallback();
          _this.armTimeout();
          return;
        }
        _this.setState('failed');
      }, 8000);
    }
  }, {
    key: "clearTimer",
    value: function clearTimer() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    }
  }, {
    key: "onHandshake",
    value: function onHandshake(peer) {
      var expected = this.mod.server_publickey;
      if (!expected || (peer === null || peer === void 0 ? void 0 : peer.publicKey) !== expected) {
        return false;
      }
      this.clearTimer();
      this.setState('connected');
      return true;
    }
  }, {
    key: "onDisconnect",
    value: function onDisconnect(publicKey) {
      var expected = this.mod.server_publickey;
      if (expected && publicKey !== expected) {
        return;
      }
      if (this.state === 'connected' && !this.tried_fallback) {
        this.connectFallback();
        this.armTimeout();
        return;
      }
      this.clearTimer();
      this.setState('failed');
    }
  }, {
    key: "setState",
    value: function setState(state) {
      var _this$mod$main;
      this.state = state;
      var key = (_this$mod$main = this.mod.main) === null || _this$mod$main === void 0 ? void 0 : _this$mod$main.adminkey_ui;
      if (key && typeof key.updateConnection === 'function') {
        key.updateConnection();
      }
    }
  }]);
}();
module.exports = AdminServerConnection;